var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57144 6.14062C8.13178 6.26282 8.64507 6.54379 9.04996 6.94995C9.32856 7.22852 9.54956 7.55924 9.70034 7.92323C9.85111 8.28721 9.92872 8.67733 9.92872 9.07131C9.92872 9.46528 9.85111 9.8554 9.70034 10.2194C9.54956 10.5834 9.32856 10.9141 9.04996 11.1927L7.12146 13.1212C6.84289 13.3998 6.51217 13.6208 6.14819 13.7715C5.7842 13.9223 5.39409 13.9999 5.00011 13.9999C4.60613 13.9999 4.21601 13.9223 3.85203 13.7715C3.48805 13.6208 3.15733 13.3998 2.87876 13.1212C2.60016 12.8426 2.37916 12.5119 2.22838 12.1479C2.0776 11.7839 2 11.3938 2 10.9998C2 10.6058 2.0776 10.2157 2.22838 9.85173C2.37916 9.48774 2.60016 9.15702 2.87876 8.87845L4.80726 6.94995",
    stroke: "#1E2DBE",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42856 9.85929C7.86823 9.7371 7.35494 9.45613 6.95005 9.04996C6.67145 8.77139 6.45045 8.44067 6.29967 8.07669C6.14889 7.71271 6.07129 7.32259 6.07129 6.92861C6.07129 6.53463 6.14889 6.14451 6.29967 5.78053C6.45045 5.41655 6.67145 5.08583 6.95005 4.80726L8.87855 2.87876C9.15712 2.60016 9.48784 2.37916 9.85182 2.22838C10.2158 2.0776 10.6059 2 10.9999 2C11.3939 2 11.784 2.0776 12.148 2.22838C12.512 2.37916 12.8427 2.60016 13.1213 2.87876C13.3999 3.15733 13.6208 3.48805 13.7716 3.85203C13.9224 4.21601 14 4.60613 14 5.00011C14 5.39409 13.9224 5.7842 13.7716 6.14819C13.6208 6.51217 13.3999 6.84289 13.1213 7.12146L11.1928 9.04996",
    stroke: "#1E2DBE",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlo);
export default __webpack_public_path__ + "static/media/ILO.172df174eb7ac17e5dd335c0374cc500.svg";
export { ForwardRef as ReactComponent };